import React from 'react'

let pucksettings = [];
pucksettings['fontsizes'] = [
    { label: "10px", value: "fs-10" },
    { label: "11px", value: "fs-11" },
    { label: "12px", value: "fs-12" },
    { label: "13px", value: "fs-13" },
    { label: "14px", value: "fs-14" },
    { label: "15px", value: "fs-15" },
    { label: "16px", value: "fs-16" },
    { label: "17px", value: "fs-17" },
    { label: "18px", value: "fs-18" },
    { label: "19px", value: "fs-19" },
    { label: "20px", value: "fs-20" },
    { label: "21px", value: "fs-21" },
    { label: "22px", value: "fs-22" },
    { label: "23px", value: "fs-23" },
    { label: "24px", value: "fs-24" },
    { label: "25px", value: "fs-25" },
    { label: "26px", value: "fs-26" },
    { label: "27px", value: "fs-27" },
    { label: "28px", value: "fs-28" },
    { label: "29px", value: "fs-29" },
    { label: "30px", value: "fs-30" },
    { label: "31px", value: "fs-31" },
    { label: "32px", value: "fs-32" },
    { label: "33px", value: "fs-33" },
    { label: "34px", value: "fs-34" },
    { label: "35px", value: "fs-35" },
    { label: "36px", value: "fs-36" },
    { label: "37px", value: "fs-37" },
    { label: "38px", value: "fs-38" },
    { label: "39px", value: "fs-39" },
    { label: "40px", value: "fs-40" },
    { label: "41px", value: "fs-41" },
    { label: "42px", value: "fs-42" },
    { label: "43px", value: "fs-43" },
    { label: "44px", value: "fs-44" },
    { label: "45px", value: "fs-45" },
    { label: "46px", value: "fs-46" },
    { label: "47px", value: "fs-47" },
    { label: "48px", value: "fs-48" },
    { label: "49px", value: "fs-49" },
    { label: "50px", value: "fs-50" },
    { label: "51px", value: "fs-51" },
    { label: "52px", value: "fs-52" },
    { label: "53px", value: "fs-53" },
    { label: "54px", value: "fs-54" },
    { label: "55px", value: "fs-55" },
    { label: "56px", value: "fs-56" },
    { label: "57px", value: "fs-57" },
    { label: "58px", value: "fs-58" },
    { label: "59px", value: "fs-59" },
    { label: "60px", value: "fs-60" },
    { label: "61px", value: "fs-61" },
    { label: "62px", value: "fs-62" },
    { label: "63px", value: "fs-63" },
    { label: "64px", value: "fs-64" },
    { label: "65px", value: "fs-65" },
    { label: "66px", value: "fs-66" },
    { label: "67px", value: "fs-67" },
    { label: "68px", value: "fs-68" },
    { label: "69px", value: "fs-69" },
    { label: "70px", value: "fs-70" },
    { label: "71px", value: "fs-71" },
    { label: "72px", value: "fs-72" },
    { label: "73px", value: "fs-73" },
    { label: "74px", value: "fs-74" },
    { label: "75px", value: "fs-75" },
    { label: "76px", value: "fs-76" },
    { label: "77px", value: "fs-77" },
    { label: "78px", value: "fs-78" },
    { label: "79px", value: "fs-79" },
    { label: "80px", value: "fs-80" },
    { label: "81px", value: "fs-81" },
    { label: "82px", value: "fs-82" },
    { label: "83px", value: "fs-83" },
    { label: "84px", value: "fs-84" },
    { label: "85px", value: "fs-85" },
    { label: "86px", value: "fs-86" },
    { label: "87px", value: "fs-87" },
    { label: "88px", value: "fs-88" },
    { label: "89px", value: "fs-89" },
    { label: "90px", value: "fs-90" },
    { label: "91px", value: "fs-91" },
    { label: "92px", value: "fs-92" },
    { label: "93px", value: "fs-93" },
    { label: "94px", value: "fs-94" },
    { label: "95px", value: "fs-95" },
    { label: "96px", value: "fs-96" },
    { label: "97px", value: "fs-97" },
    { label: "98px", value: "fs-98" },
    { label: "99px", value: "fs-99" },
    { label: "100px", value: "fs-100" }
];
pucksettings['fontweight'] = [
    { label: "Regular", value: "fw-400" },
    { label: "Medium", value: "fw-500" },
    { label: "Semi-Bold", value: "fw-600" },
    { label: "Bold", value: "fw-700" },
    { label: "Extra Bold", value: "fw-800" },
];
pucksettings['spacing'] = [
    { label: "0px", value: "0px" },
    { label: "1px", value: "1px" },
    { label: "2px", value: "2px" },
    { label: "3px", value: "3px" },
    { label: "4px", value: "4px" },
    { label: "5px", value: "5px" },
    { label: "6px", value: "6px" },
    { label: "7px", value: "7px" },
    { label: "8px", value: "8px" },
    { label: "9px", value: "9px" },
    { label: "10px", value: "10px" },
    { label: "11px", value: "11px" },
    { label: "12px", value: "12px" },
    { label: "13px", value: "13px" },
    { label: "14px", value: "14px" },
    { label: "15px", value: "15px" },
    { label: "16px", value: "16px" },
    { label: "17px", value: "17px" },
    { label: "18px", value: "18px" },
    { label: "19px", value: "19px" },
    { label: "20px", value: "20px" },
    { label: "21px", value: "21px" },
    { label: "22px", value: "22px" },
    { label: "23px", value: "23px" },
    { label: "24px", value: "24px" },
    { label: "25px", value: "25px" },
    { label: "26px", value: "26px" },
    { label: "27px", value: "27px" },
    { label: "28px", value: "28px" },
    { label: "29px", value: "29px" },
    { label: "30px", value: "30px" },
    { label: "31px", value: "31px" },
    { label: "32px", value: "32px" },
    { label: "33px", value: "33px" },
    { label: "34px", value: "34px" },
    { label: "35px", value: "35px" },
    { label: "36px", value: "36px" },
    { label: "37px", value: "37px" },
    { label: "38px", value: "38px" },
    { label: "39px", value: "39px" },
    { label: "40px", value: "40px" },
    { label: "41px", value: "41px" },
    { label: "42px", value: "42px" },
    { label: "43px", value: "43px" },
    { label: "44px", value: "44px" },
    { label: "45px", value: "45px" },
    { label: "46px", value: "46px" },
    { label: "47px", value: "47px" },
    { label: "48px", value: "48px" },
    { label: "49px", value: "49px" },
    { label: "50px", value: "50px" },
    { label: "51px", value: "51px" },
    { label: "52px", value: "52px" },
    { label: "53px", value: "53px" },
    { label: "54px", value: "54px" },
    { label: "55px", value: "55px" },
    { label: "56px", value: "56px" },
    { label: "57px", value: "57px" },
    { label: "58px", value: "58px" },
    { label: "59px", value: "59px" },
    { label: "60px", value: "60px" },
    { label: "61px", value: "61px" },
    { label: "62px", value: "62px" },
    { label: "63px", value: "63px" },
    { label: "64px", value: "64px" },
    { label: "65px", value: "65px" },
    { label: "66px", value: "66px" },
    { label: "67px", value: "67px" },
    { label: "68px", value: "68px" },
    { label: "69px", value: "69px" },
    { label: "70px", value: "70px" },
    { label: "71px", value: "71px" },
    { label: "72px", value: "72px" },
    { label: "73px", value: "73px" },
    { label: "74px", value: "74px" },
    { label: "75px", value: "75px" },
    { label: "76px", value: "76px" },
    { label: "77px", value: "77px" },
    { label: "78px", value: "78px" },
    { label: "79px", value: "79px" },
    { label: "80px", value: "80px" },
    { label: "81px", value: "81px" },
    { label: "82px", value: "82px" },
    { label: "83px", value: "83px" },
    { label: "84px", value: "84px" },
    { label: "85px", value: "85px" },
    { label: "86px", value: "86px" },
    { label: "87px", value: "87px" },
    { label: "88px", value: "88px" },
    { label: "89px", value: "89px" },
    { label: "90px", value: "90px" },
    { label: "91px", value: "91px" },
    { label: "92px", value: "92px" },
    { label: "93px", value: "93px" },
    { label: "94px", value: "94px" },
    { label: "95px", value: "95px" },
    { label: "96px", value: "96px" },
    { label: "97px", value: "97px" },
    { label: "98px", value: "98px" },
    { label: "99px", value: "99px" },
    { label: "100px", value: "100px" }
];
pucksettings['padddingTop'] = [
    { label: "None", value: "pt-0" },
    { label: "Small", value: "pt-30" },
    { label: "Medium", value: "pt-60" },
    { label: "Large", value: "pt-90" },
    { label: "Extra Large", value: "pt-150" },
];
pucksettings['padddingBottom'] = [
    { label: "None", value: "pb-0" },
    { label: "Small", value: "pb-30" },
    { label: "Medium", value: "pb-60" },
    { label: "Large", value: "pb-90" },
    { label: "Extra Large", value: "pb-150" },
];

pucksettings['VAlign'] = [
    { label: "Top", value: "align-items-start" },
    { label: "Center", value: "align-items-center" },
    { label: "Bottom", value: "align-items-end" },
];

pucksettings['HAlign'] = [
    { label: "Left", value: "justify-content-start" },
    { label: "Center", value: "justify-content-center" },
    { label: "Right", value: "justify-content-end" },
];

pucksettings['TextAlign'] = [
    { label: "Left", value: "left" },
    { label: "Center", value: "center" },
    { label: "Right", value: "right" },
    { label: "Justify", value: "justify" },
];
pucksettings['BorderStyle'] = [
    { label: "dashed", value: "dashed" },
    { label: "dotted", value: "dotted" },
    { label: "solid", value: "solid" },
    { label: "none", value: "none" },
];

pucksettings['BorderWidth'] = [
    { label: "none", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
];

pucksettings['BorderRadius'] = [
    { label: "none", value: 0 },
    { label: "full-rounded", value: 999 },
    ...Array.from({ length: 50 }, (_, i) => ({
        label: String(i + 1),
        value: i + 1,
    })),
];

pucksettings['ButtonStyle'] = [
    { label: "Primary", value: "primary" },
    { label: "Secondary", value: "secondary" },
];

pucksettings['imageAspectRatio'] = [
    { label: "auto", value: "auto" },
    { label: "1/1", value: "1/1" },
    { label: "2/3", value: "2/3" },
    { label: "3/2", value: "3/2" },
    { label: "3/4", value: "3/4" },
    { label: "4/3", value: "4/3" },
];

pucksettings['buttonIcon'] = [
    { label: "Yes", value: "yes" },
    { label: "No", value: "no" },
];
pucksettings['buttonAction'] = [
    { value: "JumpToPage", label: 'Jump to Page' },
    { value: "JumpToUrl", label: 'Jump to URL' },
    { value: "OpenPopup", label: 'Open Popup' },
    { value: "ClosePopup", label: 'Close Popup' },
    { value: "ResetForm", label: 'Reset Form' },
    { value: "JumpToReport", label: 'Jump to Download Report' },
    { value: "JumpToMethod", label: 'Jump to Method' },
];

pucksettings['sectionStyle'] = [
    { label: "Style 1", value: "style1" },
    { label: "Style 2", value: "style2" },
];

pucksettings['selectPage'] = [];
pucksettings['ItemsPerRow'] = [
    { label: "1", value: "1" },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
];
pucksettings['containerOptions'] = [
    { label: "Container", value: "container" },
    { label: "Full Width", value: "container-fluid" },
    { label: "Edge to edge", value: "container-fluid p-0" },
];
pucksettings['fieldType'] = [
    { label: "Number", value: "number" },
    { label: "%", value: "percentage" },
    { label: "£", value: "euro" },
];

pucksettings['heightlightColumn'] = [
    { label: "None", value: "none" },
    { label: "1st", value: "1st" },
    { label: "2nd", value: "2nd" },
    { label: "3rd", value: "3rd" },
    { label: "4th", value: "4th" },
];

pucksettings['chartType'] = [
    { label: "Pie Chart", value: "pie" },
    { label: "Bar Chart", value: "bar" },
];

pucksettings['iconPosition'] = [
    { label: "Left", value: "left" },
    { label: "Right", value: "right" },
];

pucksettings['iconWithTextPlacement'] = [
    { label: "Left", value: "left" },
    { label: "Top", value: "top" },
    { label: "Right", value: "right" },
    { label: "Bottom", value: "bottom" },
];

pucksettings['contentAlignment'] = [
    { label: "Top", value: "top" },
    { label: "Center", value: "center" },
    { label: "Bottom", value: "bottom" },
];

export default pucksettings